import { Box, LinearProgress } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useRootStore } from "../hooks/useRootStore";
import GlobalErrorDialog from "./GlobalErrorDialog";

const AppState = observer(() => {
    const { isLoading, globalError } = useRootStore();

    return (
        <>
            <GlobalErrorDialog />
            <Box className="app-state" bgcolor="#47484d" style={{ height: 30, position: "sticky", bottom: 0, zIndex: 100 }}>
                <div className='loading'>{isLoading ? <LinearProgress /> : ''}</div>
                <Box id='global-error' color="red" sx={{ display: "block", height: 30 }}>{globalError.code == 0 ? '' : globalError.message}</Box>
            </Box >
        </>
    )
});

export default AppState;